import { Environment, Region } from '@bringg/frontend-utils/dist/common/types';

export enum REGIONS {
	'development',
	'eu-west-1' = 1,
	'us-east-1' = 2,
	'us-east-1-gcp' = 3,
	// 4 was used for au environment
	'eu-west-1-gcp' = 5,
	'us-east-4-gcp' = 6
}

const DEFAULT_REGION = 'default_region';

export default class RegionService {
	private readonly configuration: Environment;

	constructor(config: Environment) {
		this.configuration = config;
	}

	getConfigByRegion(): Region {
		const regionId = this.getRegionFromUrl() ? Number(this.getRegionFromUrl()) : null;
		let regionName;

		for (let region of Object.keys(REGIONS)) {
			if (Number(REGIONS[region]) === regionId) {
				regionName = region;
			}
		}
		return regionName
			? this.configuration.regions[regionName]
			: this.configuration.regions[this.configuration[DEFAULT_REGION]];
	}

	private getRegionFromUrl() {
		const urlParams = new URLSearchParams(window.location.hash);

		if (urlParams) {
			return urlParams.get('e');
		}
	}
}
